import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormPlanningForTheFuture } from "../Models/Forms/IFormPlanningForTheFuture";

@Injectable()
export class FormPlanningForTheFutureService extends BaseService {

  _baseUrl: string = "";
  formTransitionPlanningDB: any = [];

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormPlanningForTheFuture(id: number) {
    return this._http.get(this._baseUrl + "api/FormPlanningForTheFuture/" + id)
      .map((response: IFormPlanningForTheFuture) => response as IFormPlanningForTheFuture)
      .catch(this.errorHandler);
  }

  insertUpdateFormPlanningForTheFuture(formPlanningForTheFutureDetails: IFormPlanningForTheFuture) {
    return this._http.post(this._baseUrl + 'api/FormPlanningForTheFuture', formPlanningForTheFutureDetails)
      .map((response: IFormPlanningForTheFuture) => response as IFormPlanningForTheFuture)
      .catch(this.errorHandler);
  }

  //deleteFormPlanningForTheFuture(id) {
  //  return this._http.delete(this._baseUrl + "api/FormPlanningForTheFuture" + id)
  //    .map((response: IFormPlanningForTheFuture) => response as IFormPlanningForTheFuture)
  //    .catch(this.errorHandler)
  //}

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}
